<div class="modal-header">
  <h4 class="modal-title">Select an Address</h4>
  <button unity-button class="close" classes="icon-only icon-only-large on_dark" type="button" (click)="cancelSelection()">
    <svg class="unity-icon unity-icon-times">
      <use xlink:href="#unity-icon-times"></use>
    </svg>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-6">
      <unity-card title="Entered">
        <div>{{ enteredAddress.Address_Line_1 }}</div>
        <div *ngIf="enteredAddress.Address_Line_2">{{ enteredAddress.Address_Line_2 }}</div>
        <div *ngIf="enteredAddress.Address_Line_3">{{ enteredAddress.Address_Line_3 }}</div>
        <div>{{ enteredAddress.City }} {{ enteredAddress.State }} {{ enteredAddress.Zip }}</div>
        <div style="text-align: right">
          <button unity-button type="button" (click)="validationOverride()" classes="secondary">Use Entered</button>
        </div>
      </unity-card>
    </div>
    <div class="col-6">
      <div style="max-height: 400px; overflow-y: auto; padding-right: 5px">
        <unity-card *ngFor="let address of addresses; index as i" title="Validated Address">
          <div>{{ address.Address_Line_1 }}</div>
          <div *ngIf="address.Address_Line_2">{{ address.Address_Line_2 }}</div>
          <div *ngIf="address.Address_Line_3">{{ address.Address_Line_3 }}</div>
          <div>{{ address.City }} {{ address.State }} {{ address.Zip }}</div>
          <div style="text-align: right">
            <button unity-button type="button" (click)="acceptValidated(address)" classes="primary">Accept</button>
          </div>
        </unity-card>
        <unity-card *ngIf="!addresses || addresses.length == 0" title="Address Validation Failed">
          <div>Address not found.</div>
        </unity-card>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button unity-button type="button" (click)="cancelSelection()" classes="tertiary">Cancel</button>
</div>
